import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("LoginPage", {
  title: "Login Page",
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    ...defaultPageProperties,
    "backgroundImage",
    "emailFieldLabel",
    "passFieldLabel",
    "passRepeatFieldLabel",
    "newPassFieldLabel",
    "newPassRepFieldLabel",
    "oldPassFieldLabel",
    "userLoggedIn",
    "backToLoginBtn",
    "errorOccured",
    "errorPasswordsDiffer",
    "errorLoginStorage",
  ],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    {
      title: "Login View",
      properties: [
        "loginBackToHomepageBtn",
        "loginHeader",
        "loginReset",
        "loginResetLink",
        "loginNewAccount",
        "loginNewAccountLink",
        "loginButton",
      ],
    },
    {
      title: "Reset View",
      properties: ["resetHeader", "resetDescription", "resetButton"],
    },
    {
      title: "Set new password View",
      properties: ["setPassHeader", "setPassDescription", "setPassButton"],
    },
    {
      title: "Change password View",
      properties: [
        "changePassHeader",
        "changePassDescription",
        "changePassButton",
      ],
    },
    ...metadataPropertiesGroups,
  ],
  validations: [...defaultPageValidations, ...metadataValidations],
  initialContent: {
    ...defaultPageInitialContent,
    changePassButton: "Passwort ändern",
    changePassDescription:
      "Bitte geben Sie Ihr bisheriges und neues Passwort ein",
    changePassHeader: "Passwort ändern",
    backToLoginBtn: "Zurück",
    emailFieldLabel: "Benutzer Email",
    errorLoginStorage:
      "Lokaler Speicher ist in diesem Browser aktuell nicht verfügar. Überprüfen Sie Ihre Einstellungen oder nutzen Sie einen anderen Browser",
    errorOccured: "Ein Fehler ist aufgetreten",
    errorPasswordsDiffer:
      "Passwort und wiederholtes Passwort sind nicht dasselbe",
    loginBackToHomepageBtn: "Zurück zur Startseite",
    loginButton: "Anmelden",
    loginHeader: "Hallo! Bitte melden Sie sich mit Ihrem myTROX-Konto an",
    loginNewAccount: "Account erstellen",
    loginReset: "Passwort zurücksetzen",
    newPassFieldLabel: "Neues Passwort",
    newPassRepFieldLabel: "Neues Passwort wiederholt",
    oldPassFieldLabel: "Altes Passwort",
    passFieldLabel: "Passwort",
    passRepeatFieldLabel: "Passwort wiederholen",
    setPassButton: "Passwort festlegen",
    setPassDescription: "Bitte legen Sie Ihr neues Passwort fest",
    setPassHeader: "Passwort festlegen",
    resetButton: "Passwort zurücksetzen",
    resetDescription:
      "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts",
    resetHeader: "Passwort zurücksetzen",
    userLoggedIn: "Sie sind bereits eingeloggt",
    ...metadataInitialContent,
  },
});
